import { useMutation } from '@tanstack/react-query';
import { MarketingMediumTemplates } from '@prisma/client';
import useGetMarketingData from './useGetMarketingData';
import { updateSmsTemplate } from '../../services/marketing';

interface Options {
  onSuccess?: (result: MarketingMediumTemplates) => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useUpdateSmsTemplate({ onSuccess, onError }: Options = {}) {
  const {
    data: marketingData,
    isFetching: isFetchingMarketing,
    isEnabled,
  } = useGetMarketingData();

  return useMutation({
    mutationFn: async (templateId: number) => {
      if (!marketingData?.id || isFetchingMarketing || !isEnabled) return null;
      const result = await updateSmsTemplate(marketingData.id, templateId);
      return result;
    },
    onSuccess: async result => {
      if (!result) return;
      await onSuccess?.(result);
    },
    onError,
  });
}

export default useUpdateSmsTemplate;
